import { render, staticRenderFns } from "./IndagineEpidemiologicaList.vue?vue&type=template&id=c10689a8"
import script from "./IndagineEpidemiologicaList.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports